import { createContext } from 'react';

const dispositivoContext = createContext();

export default dispositivoContext;